<template>
  <div :data-id="question.id" :data-type="`${question.typeEnum}-${question.type}`">
    <template v-if="question.image != '0'">
      <b-row align-v="center">
        <b-col :cols="9">
          <div v-if="question.content !== null" class="mb-3 exam__question__article">
            <div v-if="question.content" v-html="question.content"></div>
          </div>
        </b-col>
        <b-col :cols="3" class="text-center">
          <b-img-lazy thumbnail v-if="question.image != '0'" :src="cdnUrl + question.image" width="256"></b-img-lazy>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <div v-if="question.content !== null" class="mb-3 exam__question__article">
        <div v-if="question.content" v-html="question.content"></div>
      </div>
    </template>
    <template v-if="question.type == 104">
      <b-row class="d-flex flex-wrap align-items-center" align-h="center">
        <b-col xs="6" md="6"
          align-self="center"
          v-for="(image, indexImage) in getImageList"
          :key="indexImage"
          class="align-middle"
        >
          <div class="text-center mb-3">
            <b-img-lazy thumbnail :src="cdnUrl + image.image" width="256"></b-img-lazy>
            <div>
              <span class="mr-3" v-if="image.key">{{ image.key }}.</span>
              <span class="mr-3" v-else>{{ (indexImage + 1 + 9).toString(36).toUpperCase() }}. </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
    <template v-for="childQuestion in question.children">
      <template v-if="editable">
        <QuestionSingle :key="childQuestion.id" :ref="`question-item-${childQuestion.id}`" :id="`item-${childQuestion.number}`" :data-id="childQuestion.id" :data-type="`${childQuestion.typeEnum}-${childQuestion.type}`" class="question__item" :parent="question" :question="childQuestion" :editable="true" v-on:selectAnswer="selectAnswer" :response="null" :isExplain="isExplain" />
      </template>
      <template v-else>
        <QuestionSingle :key="childQuestion.id" :id="`item-${childQuestion.number}`" :data-id="childQuestion.id" :data-type="`${childQuestion.typeEnum}-${childQuestion.type}`" class="question__item" :parent="question" :question="childQuestion" :editable="false" :response="getQuestionResponse(childQuestion.id)" :isExplain="isExplain" />
      </template>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'
import QuestionSingle from './QuestionSingle'

export default {
  name: 'QuestionGroup',
  props: {
    question: Object,
    response: Array,
    editable: Boolean,
    isExplain: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
    }
  },
  components: {
    QuestionSingle,
  },
  computed: {
    questionTemplate() {
      switch (this.question.type) {
        // Reading
        case 103:
          return 'QuestionReadingGroupText'

        case 104:
          return 'QuestionReadingGroupImage'

        // Listening
        case 155:
          return 'QuestionListeningGroupSelect'
      }

      return null;
    },
    getImageList() {
      if (this.question.images) {
        return JSON.parse(this.question.images)
      }

      return []
    }
  },
  methods: {
    fillQuestionNumber() {
      if (this.question.content != null) {
        const regex = /\{\{CAU_HOI\}\}/ig;
        const matches = regex.exec(this.question.content)

        if (matches) {
          this.question.children.forEach(item => {
            this.question.content = this.question.content.replace('{{CAU_HOI}}', `[${item.number}]`)
          })
        }
      }
    },
    getQuestionResponse(id) {
      let answer = null
      
      if (this.response) {
        this.response.forEach(item => {
          if (item.question_id === id) {
            answer = item
          }
        })
      }

      return answer
    },
    selectAnswer(dataAnswer) {
      this.$emit('selectAnswer', dataAnswer)
    }
  },
  mounted() {
    this.fillQuestionNumber();

    var div = document.createElement("div")
    div.innerHTML = this.question.content

    if (!div.innerText.trim()) {
      this.question.content = null
    }
  }
}
</script>